module.exports = [{"toLink":"/aboutme","title":"ABOUT ME"},{"toLink":"/output","title":"OUTPUT"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/contents.json
// module id = 8F+s
// module chunks = 0